export default "__VITE_ASSET__G5OAXoN6__"